import { render } from "./FeeModalSectionFiles.vue?vue&type=template&id=2da5d09d"
import script from "./FeeModalSectionFiles.vue?vue&type=script&lang=js"
export * from "./FeeModalSectionFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__